import React, { useState } from 'react';
import CookieConsent from "react-cookie-consent";

export default function CookieBanner() {
  const [isLoading, setIsLoading] = useState(false);

  const logConsent = async (action, preferences = null) => {
    try {
      setIsLoading(true);
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      
      const response = await fetch(`${backendUrl}/api/consent/${action}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(preferences ? { preferences } : { action })
      });
      
      if (!response.ok) {
        console.warn('Failed to log consent to backend');
      }
    } catch (error) {
      console.warn('Failed to log consent:', error);
      // Don't block user experience if logging fails
    } finally {
      setIsLoading(false);
    }
  };

  const handleAcceptAll = async () => {
    const preferences = {
      essential: true,
      analytics: true,
      functional: true
    };
    
    await logConsent('accept', preferences);
    
    // Enable analytics and other tracking if needed
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted'
      });
    }
  };

  const handleDeclineAll = async () => {
    const preferences = {
      essential: true,
      analytics: false,
      functional: false
    };
    
    await logConsent('decline', preferences);
    
    // Disable analytics tracking
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'denied'
      });
    }
  };

  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept All Cookies"
      declineButtonText="Only Essential Cookies"
      enableDeclineButton
      cookieName="harmonyLivingCookieConsent"
      style={{ 
        background: "linear-gradient(135deg, #2c3e50 0%, #34495e 100%)",
        fontSize: "15px",
        padding: "20px",
        boxShadow: "0 -4px 20px rgba(0,0,0,0.15)",
        borderTop: "3px solid #3498db"
      }}
      buttonStyle={{ 
        background: "#3498db", 
        color: "white",
        fontSize: "14px",
        borderRadius: "8px",
        padding: "12px 24px",
        border: "none",
        fontWeight: "600",
        cursor: "pointer",
        marginRight: "10px",
        transition: "all 0.3s ease"
      }}
      declineButtonStyle={{
        background: "transparent",
        color: "#3498db",
        fontSize: "14px", 
        borderRadius: "8px",
        padding: "12px 24px",
        border: "2px solid #3498db",
        fontWeight: "600",
        cursor: "pointer",
        transition: "all 0.3s ease"
      }}
      expires={365}
      onAccept={handleAcceptAll}
      onDecline={handleDeclineAll}
      flipButtons={false}
      buttonWrapperClasses="cookie-button-wrapper"
      contentClasses="cookie-content"
    >
      <div style={{ 
        display: "flex", 
        alignItems: "center", 
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: "15px"
      }}>
        <div style={{ flex: 1, minWidth: "300px" }}>
          <div style={{ 
            fontWeight: "600", 
            marginBottom: "8px",
            color: "#ecf0f1"
          }}>
            🍪 We use cookies to enhance your experience
          </div>
          <div style={{ 
            color: "#bdc3c7", 
            lineHeight: "1.4",
            fontSize: "14px"
          }}>
            We use cookies to provide personalized content, analyze site traffic, and enhance your browsing experience. 
            By clicking "Accept All Cookies", you agree to our use of cookies as described in our{" "}
            <button 
              onClick={() => {
                const privacyButtons = document.querySelectorAll('button');
                privacyButtons.forEach(btn => {
                  if (btn.textContent.includes('Privacy Policy')) {
                    btn.click();
                  }
                });
              }}
              style={{ 
                color: "#3498db", 
                textDecoration: "underline",
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: "inherit"
              }}
            >
              Privacy Policy
            </button>.
          </div>
        </div>
        
        <div style={{ 
          display: "flex", 
          gap: "10px",
          alignItems: "center",
          flexWrap: "wrap"
        }}>
          {isLoading && (
            <div style={{ 
              color: "#bdc3c7", 
              fontSize: "12px",
              marginRight: "10px"
            }}>
              Saving preferences...
            </div>
          )}
        </div>
      </div>
    </CookieConsent>
  );
}